import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function AdultStrokeIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				d="M12.0645 7.0237C13.4774 7.0237 14.629 5.89573 14.629 4.51185C14.629 3.12796 13.4774 2 12.0645 2C10.6516 2 9.5 3.12796 9.5 4.51185C9.5 5.89573 10.6516 7.0237 12.0645 7.0237ZM12.0645 3.23223C12.7806 3.23223 13.371 3.81043 13.371 4.51185C13.371 5.21327 12.7903 5.79147 12.0645 5.79147C11.3387 5.79147 10.7581 5.21327 10.7581 4.51185C10.7581 3.81043 11.3484 3.23223 12.0645 3.23223Z"
				fill="currentColor"
			/>
			<path
				d="M15.329 8.73784C14.6581 8 13.7118 8 12 8C10.2882 8 9.33333 8 8.67097 8.73784C8 9.47567 8 10.5162 8 12.3986V13.8176C8 14.8108 8 15.4067 8.4129 15.8703C8.72258 16.2108 9.10108 16.2959 9.63441 16.3149H9.72043V19.4932C9.72043 20.4865 9.72043 21.0824 10.1333 21.5459C10.5462 22.0094 11.0968 22 12 22C12.9032 22 13.4452 22 13.8667 21.5459C14.2882 21.0919 14.2796 20.4865 14.2796 19.4932V16.3243H14.3656C14.8989 16.2959 15.2774 16.2203 15.5871 15.8703C16 15.4162 16 14.8108 16 13.8176V12.3986C16 10.5068 16 9.46621 15.329 8.73784ZM14.8817 13.8176C14.8817 14.4608 14.8817 14.8676 14.8043 14.9811L14.7785 15.0095C14.6753 15.0851 14.3054 15.0946 13.7204 15.0946C13.4108 15.0946 13.1613 15.3689 13.1613 15.7095V19.4932C13.1613 20.1365 13.1613 20.5432 13.0839 20.6567L13.0581 20.6851C12.9548 20.7608 12.5849 20.7703 12 20.7703C11.4151 20.7703 11.0452 20.7703 10.9419 20.6851L10.9161 20.6567C10.8473 20.5432 10.8387 20.1365 10.8387 19.4932V15.7095C10.8387 15.3689 10.5892 15.0946 10.2796 15.0946C9.69462 15.0946 9.32473 15.0946 9.22151 15.0095L9.1957 14.9811C9.12688 14.8676 9.11828 14.4608 9.11828 13.8176V12.3986C9.11828 10.7243 9.13548 9.95811 9.46237 9.60811C9.78925 9.24865 10.4774 9.22973 12 9.22973C13.5226 9.22973 14.2194 9.24865 14.5376 9.60811C14.8645 9.96757 14.8817 10.7243 14.8817 12.3986V13.8176Z"
				fill="currentColor"
			/>
		</svg>
	);
}

AdultStrokeIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default AdultStrokeIcon;
